// eslint-disable-next-line no-unused-vars
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

let callMap = {};
/**
 * 
 * @param {'get'|'post'|'put'|'delete'} method 
 * @param {any} data 
 * @param {AxiosRequestConfig} options 
 * @returns {Promise<AxiosResponse>}
 */
const requestCreator = async (method, url, data, options) => {
  let call = callMap[url];
  if (call) {
    call.cancel('Only one request allowed at a time.');
  }
  // reference a new cancel token to the current request
  call = Axios.CancelToken.source();

  // update current calls map
  callMap[url] = call;

  const params = [url];
  if (method !== 'get' && method !== 'delete') {
    // if its not a get request push data to the array
    params.push(data);
  }

  // add request options to params
  params.push({ ...options, cancelToken: call.token });

  const result = await Axios[method](...params)
  requestDone(url);
  return result;
};

// use to clean up the callMap after request is done
const requestDone = (url) => {
  delete callMap[url];
}

export default requestCreator;
